export enum ArticlesTypesEnum {
  ARTICLE = 'Article',
  FICHE_ENTREPRISE = 'FicheEntreprise',
}
